<!--nav-->
<template>
    <div id="navbar" class="navbar">
        <div class="content relative">
            <div class="nav-bg relative">
                <div class="nav-box myflex-v">
                    <div class="nav-item active" title="艺术教育资源共享行动">艺术教育资源共享行动</div>
                    <!-- <div class="nav-item" title="社区教育规范化活动目录" @click="goto('catalogList')">社区教育规范化活动目录</div> -->
                    <div class="nav-item" title="新闻·活动" @click="goto('newsActivityList')">新闻·活动</div>
                    <div class="nav-item" title="网上社区艺术教育大讲堂" @click="toShequ">网上社区艺术教育大讲堂</div>
                    <div class="nav-item" title="全民终身学习社区艺术教育资源共享行动专家库" @click="goto('expertTeacherList',{isExpert:1})">全民终身学习社区艺术教育资源共享行动专家</div>
                    <div class="nav-item" title="美育师资共享库" @click="goto('expertTeacherList',{isExpert:0})">美育师资共享库</div>
                    <div class="nav-item" title="美育地图：艺术教育资源共享" @click="goto('instStudioList')">美育地图：艺术教育资源共享</div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .navbar{position:relative;z-index:2;}
    .nav-bg{background:url(../../assets/img/navbg.png) no-repeat center;width:1400px;height:75px;-webkit-background-size:auto 100%;background-size:auto 100%;margin-left:-100px;margin-top:-110px;}
    .nav-box{position:absolute;bottom:8px;left:100px;height:52px;}
    .nav-item{color:#fff;font-size:16px;padding:0px 12px;height:100%;line-height:52px;cursor:pointer;max-width:350px;overflow:hidden;
    text-overflow: ellipsis;white-space: nowrap;}
    .nav-item.active{background:rgba(255,255,255,.3);}

    @media screen and(max-width:1200px){
        .nav-bg{background:$theme-color;width:auto;min-height:75px;height:auto;margin:-90px 0 0 0;}
        .nav-box{position:static;height:auto;flex-wrap:wrap;padding:15px 10px;}
        .nav-item{max-width:none;white-space:pre-wrap;overflow:auto;line-height:1.3;padding:10px 15px;}
        .nav-item.active{border-radius:30px;}
    }
</style>

<script>
export default {
    name: "navbar",
    components: {
    },
    data(){
        return {

        }
    },
    methods:{
        toShequ(){
            art.openShequCourse();
        },
        goto(name,query){
            const newurl = this.$router.resolve({name: name, query: query})
            window.open(newurl.href,'_blank');
        }
    }
}
</script>
